module.exports = __webpack_public_path__ + "img/propertyIndexTab3.cc19b8d2.png";